import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ParentComponent = () => {
  const iframeRef = useRef(null);
 const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const path = queryParams.get('path');
  // Send parent origin to iframe
  const sendOriginToChild = () => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        { origin: window.location.hostname },
        "*" // Must match the child iframe origin
      );
      console.log("Message sent to child iframe");
    }
  };

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.onload = () => {
        // Slight delay ensures iframe is fully ready
        setTimeout(() => {
          sendOriginToChild();
        }, 500);
      };
    }
  }, []);

  return (
    <div>
      <h2>Parent Page</h2>
      <iframe
        ref={iframeRef}
        src={path}
        title="Child Frame"
        width="100%"
        height="1000px"
      />
    </div>
  );
};

export default ParentComponent;
